import React from "react";

import Settlements from "svgs/settlements.svg";
import Cards from "svgs/cards.svg";
import EWallets from "svgs/e-wallets.svg";
import EPayments from "svgs/e-payments.svg";
import AgencyBanking from "svgs/agency-banking.svg";
import WhoWeAre from "svgs/who-we-are.svg";
import Careers from "svgs/careers.svg";
import Rails from "svgs/rails.svg";

const headerMenu = {
  "Our Solutions": [
    {
      title: "Settlements",

      to: "/solutions/settlements",
      icon: <Settlements />,
    },
    {
      title: "Cards",

      to: "/solutions/cards",
      icon: <Cards />,
    },
    {
      title: "E-wallets",

      to: "/solutions/ewallets",
      icon: <EWallets />,
    },
    {
      title: "e-Payments",
      to: "/solutions/epayments",
      icon: <EPayments />,
    },
    {
      title: "Agency banking",
      to: "/solutions/agency-banking",
      icon: <AgencyBanking />,
    },
    {
      title: "Rails",
      to: "https://rails.parkway.ng",
      icon: <Rails />,
    },
  ],
  "About Us": [
    {
      title: "Who we are",
      description: "Item Description",
      to: "/who-we-are",
      icon: <WhoWeAre />,
    },
    {
      title: "Careers",
      description: "Item Description",
      to: "/careers",
      icon: <Careers />,
    },
  ],
  Blog: {
    to: "/blog",
  },
};

export { headerMenu };
